import { z } from 'zod';
import { painSchema } from '../pain';
import { registry } from '../registry';
export const basePain = z
    .object({
    none: z.boolean().optional().register(registry, { label: 'Denies/None' }),
    pains: z.array(painSchema).optional(),
})
    .register(registry, { label: 'Pain' });
export const basePainRefined = basePain.refine((data) => {
    const hasPains = data.pains && data.pains.length > 0;
    if (data.none === undefined && !hasPains) {
        return true;
    }
    return data.none || hasPains;
}, { message: 'At least one pain entry is required or check Denies/None', path: [] });
